// Height of the colored gradient hero area. Shared by the dashboard widget
// (DashboardTitleCard) and the dashboard detail page (DashboardDetailPage) so
// the two stay visually identical.
export const DASHBOARD_HERO_HEIGHT = 272;
